import { TContentListOrder } from '@_entities/content';

import { IUseContentListStateHandlerReturn } from '../../model';
import { useContentListStateStore } from '../useContentListStateStore';

export function useContentListStateHandler(folderId: number): IUseContentListStateHandlerReturn {
	const { getFolderState, setFolderOrder, setFolderKeyword } = useContentListStateStore();

	function isContentListLoading(isLoading: boolean) {
		return getFolderState(folderId).keyword === '' && isLoading;
	}

	function isSearching(isLoading: boolean) {
		return getFolderState(folderId).keyword !== '' && isLoading;
	}

	function isSearchData() {
		return getFolderState(folderId).keyword !== '';
	}

	function isContentListEmpty(count?: number) {
		return count === 0 && !isSearchData();
	}

	function isSearchDataEmpty(count?: number) {
		return count === 0 && isSearchData();
	}

	return {
		orderState: [
			getFolderState(folderId).order,
			(order: TContentListOrder) => setFolderOrder(folderId, order),
		],
		keywordState: [
			getFolderState(folderId).keyword,
			(keyword: string) => setFolderKeyword(folderId, keyword),
		],
		isContentListLoading,
		isSearching,
		isSearchData: isSearchData(),
		isContentListEmpty,
		isSearchDataEmpty,
	};
}
